import { useEffect, useCallback } from 'react';
import { usePrevious } from 'react-use';
import { isEmpty, isEqual, debounce } from 'lodash';
import { useFormik, FormikConfig, FormikValues } from 'formik';

export const useFormikAutoSave = <TValues extends FormikValues>(
  params: FormikConfig<TValues>,
  debounceMs: number,
  skipDirty?: boolean
) => {
  const formik = useFormik<TValues>(params);

  const prevFormikValues = usePrevious<TValues>(formik.values);

  const debouncedSubmit = useCallback(
    debounce(
      () =>
        formik.validateForm().then(errors => {
          return isEmpty(errors) && formik.submitForm();
        }),
      debounceMs
    ),
    [debounceMs]
  );

  useEffect(() => {
    if (
      (skipDirty ? !!prevFormikValues : formik.dirty) &&
      !isEqual(formik.values, prevFormikValues)
    ) {
      debouncedSubmit();
    }
  }, [formik.values, prevFormikValues, params]);

  return { formik };
};
